import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';
import { IApplicantPayload, IFilterPart, ISearchPart } from 'components/models';
import {
    Applicant, ApplicantExamList, ApplicantQualification, Applicants, ApplicantQualificationDetails,
} from '../../api/ApiClient';

const initialState: State = {
    applicantList: null,
    applicantDetail: null,
    applicantQualifications: null,
    applicantArchiveExams: null,
    applicantQualificationDetails: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setApplicantList(state: State, userList: Applicants | null): State {
            return { ...state, applicantList: userList };
        },
        setApplicantDetail(state: State, applicantDetail: Applicant | null): State {
            return { ...state, applicantDetail };
        },
        cleanApplicantDetail(state: State): State {
            return { ...state, applicantDetail: null };
        },
        setApplicantQualifications(state: State, applicantQualifications: ApplicantQualification[] | null): State {
            return { ...state, applicantQualifications };
        },
        setApplicantQualificationsDetail(state: State, applicantQualificationDetails: ApplicantQualificationDetails | null): State {
            return { ...state, applicantQualificationDetails };
        },
        setApplicantArchiveExams(state: State, applicantArchiveExams: ApplicantExamList | null): State {
            return { ...state, applicantArchiveExams };
        },
    },
    effects: (dispatch: any) => ({
        async getApplicantListAsync(
          {
              searchField, searchTerm, page, pageSize, sortOrder, sortField,
          }: ISearchPart & IFilterPart,
        ) {
            const applicantQualifications = await apiConnector.execApi(dispatch, apiClient => apiClient.getApplicants(searchField, searchTerm, page, pageSize, sortOrder, sortField));
            this.setApplicantList(applicantQualifications);
        },
        async getApplicantAsync({ applicantId }: IApplicantPayload) {
            const applicantDetail = await apiConnector.execApi(dispatch, apiClient => apiClient.getApplicant(applicantId));
            this.setApplicantDetail(applicantDetail);
        },
        async getApplicantQualificationsAsync({ applicantId }: IApplicantPayload) {
            const applicantDetail = await apiConnector.execApi(dispatch, apiClient => apiClient.getApplicantQualifications(applicantId));
            this.setApplicantQualifications(applicantDetail);
        },
        async getApplicantQualificationDetailsAsync({ applicantId, examApplicationId }: IGetApplicantQualificationDetailProps) {
            const applicantQualificationDetails = await apiConnector.execApi(dispatch, apiClient => apiClient.getApplicantQualificationDetails(applicantId, examApplicationId));
            this.setApplicantQualificationsDetail(applicantQualificationDetails);

            return applicantQualificationDetails;
        },
        clearApplicantQualificationDetails() {
            this.setApplicantQualificationsDetail(null);
        },
        async getApplicantArchiveExamsAsync({
                                                applicantId, searchField, searchTerm, page, pageSize, sortOrder, sortField,
                                            }: IApplicantPayload & IFilterPart & ISearchPart) {
            const applicantArchiveExams = await apiConnector.execApi(dispatch, apiClient => apiClient.getApplicantArchiveExams(applicantId, searchField, searchTerm, page, pageSize, sortOrder, sortField));
            this.setApplicantArchiveExams(applicantArchiveExams);
        },
    }),
});

interface State {
    applicantList: Applicants | null;
    applicantDetail: Applicant | null;
    applicantQualifications: ApplicantQualification[] | null;
    applicantArchiveExams: ApplicantExamList | null;
    applicantQualificationDetails: ApplicantQualificationDetails | null;
}

interface IGetApplicantQualificationDetailProps {
    applicantId: string;
    examApplicationId: string;
}
